import React from "react";
import { Box, Card, CardContent, Skeleton, useTheme } from "@mui/material";
import {
  TEMPLATES_SECTION_SX,
  TEMPLATE_GRID_SX,
} from "../TemplatesSection/templatesSectionStyles";

/** Mirrors TemplatesHeader and TemplateCard, so nothing jumps on load. */
const TemplatesSectionSkeleton: React.FC = () => {
  const theme = useTheme();
  return (
    <Box sx={TEMPLATES_SECTION_SX}>
      <Box sx={{ mb: 6 }}>
        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, mb: 1 }}>
          <Skeleton variant="text" width={200} sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" }, mr: 2 }} />
          <Box sx={{ display: "flex", gap: 4, mt: 0.5 }}>
            {[48, 56, 88, 44].map((width) => (
              <Skeleton key={width} variant="text" width={width} sx={{ fontSize: "1rem" }} />
            ))}
          </Box>
        </Box>
        <Skeleton variant="text" sx={{ fontSize: "1rem", mt: 2, mb: 2, maxWidth: 560 }} />
      </Box>
      <Box sx={TEMPLATE_GRID_SX}>
        {Array.from({ length: 12 }).map((_, idx) => (
          <Card
            key={`template-skeleton-${idx}`}
            sx={{
              borderRadius: 2,
              border: `1px solid ${theme.palette.borders.slate}`,
              backgroundColor: theme.palette.ui.white,
              overflow: "hidden",
              boxShadow: "none",
            }}
          >
            <Skeleton variant="rectangular" width="100%" sx={{ height: { xs: 88, sm: 100 } }} />
            <CardContent
              sx={{
                p: { xs: 1, sm: 1.25 },
                "&:last-child": { pb: { xs: 1, sm: 1.25 } },
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
              }}
            >
              <Skeleton variant="text" width="70%" sx={{ fontSize: "0.85rem" }} />
              <Skeleton variant="text" width="90%" sx={{ fontSize: "0.72rem" }} />
              <Skeleton variant="rounded" width={72} height={20} sx={{ mt: 0.25 }} />
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default TemplatesSectionSkeleton;
